export enum EErrorMessages {
  MIN_LENGTH_PASSWORD = 'Your password needs to be at least 8 characters',
  PASSWORD_NO_MATCH = 'Your passwords do not match',
  PASSWORD_REQUIRED = 'This field is required',
}
